import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function ObjectionsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const objections = [{
    question: '¿Esto es bíblico?',
    answer: 'Sí. El programa está fundamentado en principios bíblicos como la renovación del entendimiento (Romanos 12:2), la fe activa (Santiago 2:17), la provisión de Dios (Filipenses 4:19) y la paz que sobrepasa todo entendimiento (Filipenses 4:7). El método R.E.V.E.L.A. no reemplaza la oración: la complementa con hábitos obedientes y acción concreta.'
  }, {
    question: '¿Sirve si soy católico(a)?',
    answer: 'Sí, completamente. El lenguaje, los versículos y el enfoque son válidos para cualquier creyente que confíe en Dios como fuente de vida y provisión. No hay contenido denominacional exclusivo: es cristiano general, respetuoso y abierto a toda persona de fe.'
  }, {
    question: '¿Y si no tengo tiempo?',
    answer: 'El método está diseñado para hacerse en 10–15 minutos al día. Si tienes tiempo de revisar el teléfono por las mañanas, tienes tiempo para esto. La clave no es cuánto tiempo dedicas, sino cuánta constancia sostienes. Un paso pequeño diario vale más que un gran esfuerzo esporádico.'
  }, {
    question: '¿Y si no siento nada cuando oro o practico?',
    answer: 'Eso es más común de lo que crees, y el programa lo aborda directamente. Incluye una sección completa sobre "qué hacer cuando no sientes nada", con pasos pequeños para avanzar incluso en días de sequía espiritual. La fe también se entrena en el silencio y en la obediencia sin emoción.'
  }, {
    question: '¿Y si ya intenté otros métodos y no funcionó?',
    answer: 'Lo que suele fallar no es el deseo sino el estado interior desde el que se practica. Este programa trabaja primero el "ruido" interno (culpa, escasez, control) antes de pedir frutos externos. Eso es lo que lo hace diferente: primero ordena el corazón, luego se avanza.'
  }, {
    question: '¿Esto tiene algo de "New Age" o ley de atracción?',
    answer: 'No. No hablamos de "universo", "vibrar alto" ni decretar caprichos al vacío. Todo está anclado en fe bíblica, oración real, gratitud y acción obediente. La visualización que usamos es una herramienta de enfoque y fe interior, no una técnica esotérica ni una filosofía ajena a la fe cristiana.'
  }, {
    question: '¿Qué pasa si lo compro y no me gusta?',
    answer: 'Tienes 7 días de garantía completa. Si sientes que el programa no es lo que esperabas, escríbenos dentro de ese plazo y te devolvemos tu dinero sin preguntas complicadas ni procesos difíciles.'
  }, {
    question: '¿En 30 días voy a ver resultados?',
    answer: 'Lo que verás en 30 días es una mente más ordenada, hábitos más constantes y una relación más estable con tu fe, tu paz y tus decisiones cotidianas. Los resultados externos dependen de muchos factores; lo que sí cambia con práctica diaria y obediente es tu estado interior y tu capacidad de caminar con claridad.'
  }];
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-245">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-247">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-12 text-center" data-id="element-248">
            Tus preguntas, respondidas con honestidad
          </h2>

          <div className="space-y-4" data-id="element-249">
            {objections.map((item, index) => <div key={index} className="bg-cream rounded-lg overflow-hidden shadow-sm" data-id="element-250">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-cream/80 transition-colors" data-id="element-251">
                  <span className="font-semibold text-navy pr-4" data-id="element-252">
                    ❓ {item.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-253" />
                </button>
                <AnimatePresence data-id="element-254">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-255">
                      <div className="px-6 pb-6 text-dark/80 leading-relaxed" data-id="element-256">
                        {item.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}